import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-film-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                {footerData.siteName}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">{footerData.slogan}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {[
                { label: '经典影片', href: '#cards' },
                { label: '电影专题', href: '#index' },
                { label: '最新动态', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '关于我们', href: '#about' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '移动观影', href: '#app' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">虚位以待，欢迎优质平台合作</p>
          </div>
        </div>

        <div className="pt-8 border-t border-background-800">
          <p className="text-xs text-background-500 text-center leading-relaxed">
            {footerData.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}